import React from "react";
import Icon from "@ant-design/icons";
const DocumentFilledSvg = ({
	width = "1rem",
	height = "1rem",
	fill = "none",
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="19"
		viewBox="0 0 18 19"
		fill="none"
	>
		<path
			d="M4.21875 1.625C3.4421 1.625 2.8125 2.2546 2.8125 3.03125V15.9688C2.8125 16.7454 3.4421 17.375 4.21875 17.375H13.7812C14.5579 17.375 15.1875 16.7454 15.1875 15.9688V10.0625C15.1875 8.5092 13.9283 7.25 12.375 7.25H10.9688C10.1921 7.25 9.5625 6.6204 9.5625 5.84375V4.4375C9.5625 2.8842 8.3033 1.625 6.75 1.625H4.21875Z"
			fill="#344054"
		/>
		<path
			d="M9.72839 1.86193C10.326 2.55236 10.6875 3.45271 10.6875 4.4375V5.84375C10.6875 5.99908 10.8134 6.125 10.9688 6.125H12.375C13.3598 6.125 14.2601 6.48653 14.9506 7.08411C14.2847 4.53491 12.2776 2.52783 9.72839 1.86193Z"
			fill="#344054"
		/>
	</svg>
);
const DocumentFilledIcon = (props) => (
	<Icon component={() => <DocumentFilledSvg {...props} />} />
);

export default DocumentFilledIcon;
